<template>
  <!-- 用户列表页面 -->
  <div class="userList">
    <div class="pageTop">
      <div class="titleBox">
        <div class="left">
          <van-icon name="arrow-left" size="28" @click="goBack" />
        </div>
        <div class="middle">
          {{ $route.meta.title }}
        </div>
        <div class="right">
          <van-dropdown-menu>
            <van-dropdown-item ref="dropDownMenuitem" @open="openMenu">
              <template slot="title">
                <div class="right-nav">
                  <img class="imgLeft" src="../../assets/icon/shaixuan.png" />
                </div>
              </template>
              <div style="height: 100%; z-index: 999">
                <van-form>
                  <div class="formItemBox van-hairline--bottom">
                    <van-field v-model="searchData.nickname" name="nickname" label="昵称" placeholder="请输入"
                      autocomplete="off" />
                  </div>
                  <div class="formItemBox van-hairline--bottom">
                    <van-field v-model="searchData.discuz_uid" name="discuz_uid" label="UID" placeholder="请输入"
                      autocomplete="off" />
                  </div>
                  <div class="formItemBox van-hairline--bottom">
                    <van-field v-model="searchData.mobile" name="手机号码" label="手机号码" placeholder="请输入"
                      autocomplete="off" />
                  </div>

                  <div class="formItemBox van-hairline--bottom">
                    <van-cell center title="是否禁言">
                      <template #right-icon>
                        <van-switch v-model="searchData.is_allow_post" active-value="0" inactive-value="" />
                      </template>
                    </van-cell>
                  </div>

                  <div class="formItemBox van-hairline--bottom">
                    <van-cell center title="是否禁号">
                      <template #right-icon>
                        <van-switch v-model="searchData.is_forbidden" active-value="1" inactive-value="" />
                      </template>
                    </van-cell>
                  </div>

                  <div class="formItemBox van-hairline--bottom">
                    <van-cell center title="VIP用户">
                      <template #right-icon>
                        <van-switch v-model="searchData.is_vip" active-value="1" inactive-value="" />
                      </template>
                    </van-cell>
                  </div>

                  <div class="formItemBox van-hairline--bottom">
                    <van-field v-model="is_audit_key" is-link readonly label="审核状态" placeholder="请选择审核状态"
                      @click="show = true" />
                  </div>

                  <div style="z-index: 8">
                    <van-popup v-model="show" round position="bottom">
                      <van-picker title="审核状态" show-toolbar :columns="statusList" @cancel="show = false"
                        @confirm="okArticleStatus" />
                    </van-popup>
                  </div>
                </van-form>
                <div class="btnRow">
                  <van-button class="resetBtn" round type="default" @click="reset"
                    style="border: 1px solid black">重置</van-button>
                  <van-button class="okBtn" round style="background: rgb(72, 113, 192); color: white" @click="submitModal"
                    size="normal">确定</van-button>
                </div>
              </div>
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
      </div>
    </div>
    <div class="pageList" ref="pageList">
      <!-- 列表页 -->
      <div style="margin-top: 50px">
        <van-pull-refresh v-model="loadDataing" @refresh="onRefresh" loading-text="内容刷新中..." success-text="刷新成功">
          <van-list v-model="loading" :finished="finished" @offset="100" loading-text="内容加载中..."
            finished-text="—————— 没有更多了 ————————" @load="onLoad" :immediate-check="false">
            <div :class="showPopoverTop ? 'boxPop' : 'box'" v-for="item in allList" :key="item.id">
              <div class="topRow">
                <div class="topRowLeft" @click="goDetail(item)">
                  <div>
                    <img class="touXiangImg" :src="item.headimgurl" mode="" />
                  </div>
                  <div class="headLeft">
                    <div class="name">
                      {{ item.nickname }}
                    </div>
                    <div>
                      <div class="uid">uid: {{ item.discuz_uid }}</div>
                    </div>
                  </div>
                </div>
                <div class="topRowRight">
                  <van-popover v-model="item.showPopover" trigger="click" theme="dark"
                    @select="selectPopover($event, item)" :actions="actions" placement="left" @open="openPopover(item)">
                    <template #reference>
                      <van-button type="info" size="mini">操作</van-button>
                    </template>
                  </van-popover>
                </div>
              </div>
              <div class="contentBox" @click="goDetail(item)">
                <span class="numBox">关注：{{ item.friends_counts }}</span>
                <span class="numBox">粉丝：{{ item.fans_counts }}</span>
                <span class="numBox">发帖：{{ item.post_counts }}</span>
                <span class="numBox">展示发帖：{{ item.post_counts_owner }}</span>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>
<script>
import {
  forbiddenmembersAPI,
  forbiddenwordsAPI,
  listAPI,
} from "@/api/userList";
import { Dialog, Toast } from "vant";
export default {
  name: "UserList",
  data() {
    return {
      showStartTime: false,
      startTime: "",
      endTime: "",
      showEndTime: false,
      currentDate: new Date(),
      maxDate: new Date(),
      username: "",
      show: false,
      message: "",
      radio: "",
      showOver: false,
      searchVal: "", // 搜索的字
      uid: "",
      actions: [{ text: "禁言" }, { text: "禁号" }],
      statusList: [
        { text: "请选择审核状态", value: "" },
        { text: "无需审核", value: "0" },
        { text: "需要审核", value: "1" },
        { text: "自动推荐", value: "2" },
      ],
      allList: [],
      loadDataing: false, // 下拉刷新是否处于加载中状态
      loading: false, //  列表是否处于加载状态，加载过程中不触发load事件
      finished: false, //  是否已加载完成，加载完成后不再触发load事件
      total: 0, // 总共多少条
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      nodata: false, // 请求接口是否没有数据
      showPopoverTop: false,
      is_audit_key: "",
      searchData: {
        curr: 1,
        nums: 10,
        nickname: "",
        discuz_uid: "",
        mobile: "",
        is_audit: "",
        is_allow_post: "",
        is_forbidden: "",
        is_vip: "",
      },
      scroll: 0,
    };
  },
  created() {
    this.$root.$children[0].keepList = ["UserList"];
  },
  mounted() {
    this.getData();
  },
  activated() {
    this.$nextTick(() => {
      document.documentElement.scrollTop = this.scroll;
    });
  },
  methods: {
    getData() {
      this.reset();
      this.searchData.curr = 1;
      this.searchData.nums = 10;
      this.pageView(this.searchData);
    },
    goBack() {
      this.$router.push({ path: "/" });
    },
    // 确定审核状态
    okArticleStatus(data) {
      this.is_audit_key = !data.value ? data.value : data.text;
      this.searchData.is_audit = data.value === "3" ? "" : data.value;
      this.show = false;
    },
    submitModal() {
      this.searchData.curr = 1;
      this.searchData.nums = 10;
      this.$refs.dropDownMenuitem.toggle();
      this.pageView(this.searchData);
    },
    openMenu() {
      // this.reset();
    },
    reset() {
      this.searchData.nickname = "";
      this.searchData.discuz_uid = "";
      this.searchData.mobile = "";
      this.searchData.is_audit = "";
      this.searchData.is_allow_post = "";
      this.searchData.is_forbidden = "";
      this.searchData.is_vip = "";
      this.is_audit_key = "";
    },
    openPopover(item) {
      // 禁言 0（is_allow_post）
      // 禁号 1（is_forbidden）
      if (item.is_allow_post === 0 && item.is_forbidden === 1) {
        this.actions = [
          { text: "禁言", icon: "success" },
          { text: "禁号", icon: "success" },
        ];
      } else if (item.is_allow_post === 1 && item.is_forbidden === 0) {
        this.actions = [{ text: "禁言" }, { text: "禁号" }];
      } else if (item.is_allow_post === 0 && item.is_forbidden === 0) {
        this.actions = [{ text: "禁言", icon: "success" }, { text: "禁号" }];
      } else if (item.is_allow_post === 1 && item.is_forbidden === 1) {
        this.actions = [{ text: "禁言" }, { text: "禁号", icon: "success" }];
      }
    },
    onSearch(val) {
      Toast(val);
    },
    // 下拉刷新(相当于重新请求第一页)
    onRefresh() {
      this.searchData.curr = 0;
      this.allList = [];
      this.loadDataing = true;
      this.onLoad();
    },
    pageView(params) {
      this.finished = false;
      this.loading = true;
      Toast.loading({ message: "数据加载中...", forbidClick: true });
      listAPI(params)
        .then((res) => {
          if (res.data.code === 0) {
            this.allList = res.data?.data || [];
            this.total = res.data.count;
          }
          if (this.allList?.length === this.total) {
            this.finished = true;
          }
          this.loading = false;
          this.loadDataing = false;
        })
        .finally(() => {
          Toast.clear();
        });
    },
    // 滚动条与底部距离小于 offset 时触发
    onLoad() {
      this.finished = false;
      this.loading = true;
      let data = this.searchData;
      this.searchData.curr++;
      listAPI(data).then((res) => {
        if (res.data.code === 0) {
          this.getList(res.data);
          this.total = res.data.count;
        }
        if (this.allList?.length === this.total) {
          this.finished = true;
        }
        this.loading = false;
        this.loadDataing = false;
        Toast.clear();
      });
    },

    getList(data) {
      data.data.map((item) => {
        this.allList.push({ ...item });
      });
    },
    searchInput() {
      console.log(this.searchVal, "搜索框的值");
    },
    openDialog() {
      this.showPopoverTop = !this.showPopoverTop;
    },
    goDetail(item) {
      let vanListScroll = document.documentElement.scrollTop;
      this.scroll = vanListScroll;
      this.$router.push({
        path: "/editUserList",
        query: { discuz_uid: item.discuz_uid },
      });
    },
    selectPopover(action, item) {
      if (action.text === "禁言") {
        var title = "";
        var is_allow = 0;
        if (item.is_allow_post === 1) {
          title = "你确定要对该用户进行禁言处理吗？";
          is_allow = 0;
        } else {
          title = "你确定要对该用户进行取消禁言处理吗？";
          is_allow = 1;
        }
        Dialog.confirm({
          title: "禁言",
          message: title,
        })
          .then(() => {
            const data = {
              uid: item.discuz_uid,
              is_allow: is_allow,
            };
            forbiddenwordsAPI(data).then((res) => {
              if (res.data?.status === 1) {
                Toast.success("禁言成功");
                this.pageView(this.searchData);
              }
            });
          })
          .catch(() => { });
      } else if (action.text === "禁号" && item.is_forbidden === 0) {
        Dialog.confirm({
          title: "禁号",
          message: "你确定要对该用户进行禁号处理吗？",
        })
          .then(() => {
            const data = {
              uid: item.discuz_uid,
              is_forbidden: 1,
            };
            forbiddenmembersAPI(data).then((res) => {
              if (res.data?.status === 1) {
                Toast.success("禁号成功");
                this.pageView(this.searchData);
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      }
    },
  },
};
</script>
<style scoped lang="less">
.userList {
  .pageTop {
    width: 100%;
    height: 100px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;

    .titleBox {
      width: 100%;
      height: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(72, 113, 192);
      color: white;
      font-size: 36px;
    }

    /deep/.van-dropdown-menu__bar {
      background: rgb(72, 113, 192);
    }

    /deep/.van-dropdown-menu__item {
      background: rgb(72, 113, 192);
    }

    .right {
      color: black;
    }

    .rightBox {
      position: fixed;
      left: 0px;
      top: 100px;
      height: 300px;
    }

    .imgLeft {
      width: 52px;
      height: 52px;
    }

    /* 弹框层样式 */
    .bottomModal {
      display: flex;
      height: 100px;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;
      font-size: 36px;
    }

    .radioItem {
      height: 120px;
      line-height: 120px;
      font-size: 30px;
    }

    .formItemBox {
      margin: 12px 0px;
    }

    .btnRow {
      display: flex;
      flex-wrap: nowrap;
      widows: 100%;
      justify-content: space-around;
      margin: 10px;

      .resetBtn {
        width: 250px !important;
      }

      .okBtn {
        width: 250px !important;
      }
    }

    .text {
      margin-left: 32px;
      font-size: 32px;
      font-weight: 600;
    }
  }

  .pageList {

    // 列表内容样式
    .boxPop {
      padding: 0px 30px;
      height: 260px;
      // margin: 32px 0px;
      padding: 32px 0px;
      border-bottom: 1px solid gray;
      // background: black;
      background-color: rgba(0, 0, 0, 0.1);
      opacity: 0.8;
    }

    .box {
      padding: 0px 30px;
      height: 200px;
      margin: 32px 0px;
      border-bottom: 2px solid #ececec;
    }

    .topRow {
      display: flex;
      justify-content: space-between;

      .topRowLeft {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .touXiangImg {
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }

        .headLeft {
          margin-left: 30px;

          .name {
            font-weight: 600;
            font-size: 32px;
          }

          .uid {
            margin-top: 8px;
            font-size: 24px;
            color: #6b6b6b;
          }
        }
      }

      .topRowRight {
        color: red;
        font-size: 24px;
        margin-top: 10px;

        .iconMore {
          display: flex;
          justify-content: flex-end;

          img {
            width: 35px;
            height: 35px;
          }
        }
      }
    }

    .contentBox {
      margin: 20px 0px;

      .numBox {
        margin-right: 10px;
      }
    }

    .timeBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 56px;

      .time {
        font-size: 24px;
        color: #6b6b6b;
      }

      .iconMore {
        display: flex;
        justify-content: flex-end;

        img {
          width: 35px;
          height: 35px;
        }
      }
    }

    .headBox {
      position: fixed;
      top: 100px;
      left: 0;
      width: 100%;
      z-index: 8;
      display: flex;
      align-items: center;
    }

    /* 弹框层样式 */
    .bottomModal {
      display: flex;
      height: 100px;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;
      font-size: 36px;
    }

    .radioItem {
      height: 120px;
      line-height: 120px;
      font-size: 30px;
    }

    .btnRow {
      display: flex;
      flex-wrap: nowrap;

      .resetBtn {
        flex: 1;
      }

      .okBtn {
        flex: 2;
      }
    }

    .noMore {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      color: #6b6b6b;
    }

    /deep/.van-overlay {
      // top: calc(100vh-250px);
      top: 250px !important;
    }

    /deep/ .van-popup--top {
      top: 248px !important;
    }
  }
}
</style>